<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="500px"
    :before-close="handleClose"
    class="recommend-dialog"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    custom-class="custom-dialog"
  >
    <div class="recommend-content">
      <div class="form-item">
        <label class="form-label">推荐级别</label>
        <el-select v-model="selectedLevel" placeholder="请选择推荐级别" class="level-select">
          <el-option
            v-for="option in levelOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave" :loading="saving" class="submit-btn">设置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {setPlatformRecommend} from '../../api/consultingService'

export default {
  name: 'RecommendSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    consultantId: {
      type: [String, Number],
      required: true
    },
    currentLevel: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedLevel: 0,
      saving: false,
      levelOptions: []
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '平台推荐'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData()
      }
    },
    currentLevel(newVal) {
      this.selectedLevel = newVal
    }
  },
  created() {
    this.initLevelOptions()
  },
  methods: {
    // 初始化推荐级别选项
    initLevelOptions() {
      const options = []

      // 10星推荐到1星推荐
      for (let i = 10; i >= 1; i--) {
        options.push({
          value: i,
          label: `${i}星推荐`
        })
      }

      // 0星推荐
      options.push({
        value: 0,
        label: '0星推荐'
      })

      // 1星不推荐到10星不推荐
      for (let i = -1; i >= -10; i--) {
        options.push({
          value: i,
          label: `${Math.abs(i)}星不推荐`
        })
      }

      this.levelOptions = options
    },

    // 初始化数据
    initData() {
      this.selectedLevel = this.currentLevel
    },

    // 保存设置
    async handleSave() {
      if (this.saving) return

      this.saving = true
      try {
        const res = await setPlatformRecommend({
          consultantId: this.consultantId,
          level: this.selectedLevel
        })

        if (res.code === 200) {
          this.$message.success('推荐级别设置成功')
          this.$emit('saveSuccess', {
            consultantId: this.consultantId,
            level: this.selectedLevel
          })
          this.handleClose()
        } else {
          this.$message.error(res.msg || '设置失败')
        }
      } catch (error) {
        console.error('设置推荐级别失败:', error)
        this.$message.error('设置失败，请稍后重试')
      } finally {
        this.saving = false
      }
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/tuijian.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 60px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }
}

.recommend-dialog {
  .recommend-content {
    .form-item {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      .form-label {
        width: 120px;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        margin-right: 16px;
        text-align: left;
      }

      .level-select {
        flex: 1;
      }
    }
  }

  .dialog-footer {
    text-align: center;
    padding: 0;

    .submit-btn {
      width: 60%;
      height: 48px;
      font-size: 18px;
      font-weight: 500;
      border-radius: 8px;
      background: #5ad3cd;
      border-color: #5ad3cd;

      &:hover {
        background: #4ab8b2;
        border-color: #4ab8b2;
      }
    }
  }
}
</style>
